import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import { auth } from "../../services/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../services/firebase";
import { LockOutlined, UserOutlined, LoadingOutlined } from "@ant-design/icons";

function Login() {
  const [credentials, setCredentials] = useState({ login: "", senha: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
    setError("");
  };

  const pegarUsuario = async (id) => {
    const ref = doc(db, "usuarios", id);
    const result = await getDoc(ref);

    if (!result.exists()) {
      setError("Usuário não encontrado no sistema.");
      return;
    }

    const data = result.data();
    const tipo = data?.tipoUsuario;

    if (!tipo) {
      setError("Usuário sem permissões definidas. Contate o administrador.");
      return;
    }

    sessionStorage.setItem("seepilUserID", id);
    sessionStorage.setItem("seepilUserType", tipo);
    sessionStorage.setItem("seepilUsuario", JSON.stringify(data));

    // Ambos vão para o dashboard
    navigate(`/${tipo}/dashboard`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const user = await signInWithEmailAndPassword(
        auth,
        credentials.login,
        credentials.senha
      );

      if (user.user.uid) {
        await pegarUsuario(user.user.uid);
      }
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      if (error.code === "auth/invalid-credential") {
        setError("E-mail ou senha incorretos.");
      } else if (error.code === "auth/too-many-requests") {
        setError("Muitas tentativas. Aguarde alguns minutos.");
      } else {
        setError("Erro ao realizar login. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Lado esquerdo - Branding */}
      <div className="login-branding">
        <div className="branding-content">
          <img
            src="/assets/logo-branca1.png"
            alt="Seepil Logo"
            className="branding-logo"
          />

          <p className="branding-subtitle">
            Sistema de Gestão de Válvulas e Certificados
          </p>
          <div className="branding-features">
            <div className="feature-item">
              <div className="feature-icon">&#10003;</div>
              <span>Gestão completa de válvulas</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">&#10003;</div>
              <span>Certificados digitais</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">&#10003;</div>
              <span>Controle de calibração</span>
            </div>
          </div>
        </div>
        <div className="branding-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </div>

      {/* Lado direito - Formulário */}
      <div className="login-form-section">
        <div className="login-form-container">
          <div className="form-header">
            <h2 className="form-title">Bem-vindo de volta</h2>
            <p className="form-subtitle">
              Entre com suas credenciais para acessar o sistema
            </p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                <span className="error-icon">!</span>
                {error}
              </div>
            )}

            <div className="input-group">
              <label htmlFor="login">E-mail</label>
              <div className="input-wrapper">
                <UserOutlined className="input-icon" />
                <input
                  id="login"
                  type="email"
                  name="login"
                  placeholder="Digite seu e-mail"
                  value={credentials.login}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="input-group">
              <label htmlFor="senha">Senha</label>
              <div className="input-wrapper">
                <LockOutlined className="input-icon" />
                <input
                  id="senha"
                  type="password"
                  name="senha"
                  placeholder="Digite sua senha"
                  value={credentials.senha}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <>
                  <LoadingOutlined className="loading-icon" />
                  Entrando...
                </>
              ) : (
                "Entrar"
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Seepil Valve Care &copy; {new Date().getFullYear()}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
